module.exports = __webpack_public_path__ + "static/media/imgOne.c5069886.jpg";